import { OdataManager } from '@/api/odata/odata-manager';
import { DrawingPackageIssueStatusHistory } from '@/api/model/interfaces';

export default class DrawingPackageIssueStatusHistoryOdata extends OdataManager<DrawingPackageIssueStatusHistory> {}
